import request from "@/utils/httpRequest.js"

 export function duration(params) {
  return request({
    url: 'page/duration',
    method: 'get',
    params: params
  })
}
